import React, { forwardRef } from "react";
import { Button } from "./Button";

export interface TriggerButtonProps {
  text?: string;
  icon?: React.ReactNode;
  disabled?: boolean;
  onClick?: () => void;
}

export const TriggerButton = forwardRef<HTMLButtonElement, TriggerButtonProps>(
  ({ text, icon, onClick, disabled = false }, ref) => {
    return (
      <Button
        ref={ref}
        size={"xs"}
        className="align-middle"
        disabled={disabled}
        onClick={onClick}
      >
        {text && <p>{text}</p>}
        {icon && (
          <div className="w-4 h-4 ml-1 flex items-center justify-center">
            {React.cloneElement(icon as React.ReactElement, {
              className: "w-full h-full",
            })}
          </div>
        )}
      </Button>
    );
  }
);
